import identity from 'lodash/identity';
import { connect } from 'react-redux';
import {
  branch, compose, withProps, mapProps, withStateHandlers,
} from 'recompose';
import { client, shouldSkip } from './helpers';
import omitProps from '../../lib/omitProps';

/**
 * options.props works as recompose mapProps
 */

export const withContainer = methodName => (options = { props: undefined, skip: undefined }) => branch(
  shouldSkip(options.skip),
  identity,
  compose(
    connect(null),
    withStateHandlers(
      () => ({ isLoading: 0 }),
      {
        beginLoading: ({ isLoading }) => () => ({ isLoading: isLoading + 1 }),
        finishLoading: ({ isLoading }) => () => ({ isLoading: isLoading - 1 }),
      },
    ),
    withProps(
      ({
        dispatch, isLoading, beginLoading, finishLoading,
      }) => ({
        [methodName]: (payload) => {
          beginLoading();
          return client(dispatch)[methodName](payload).then((data) => {
            finishLoading();
            return data;
          }).catch((error) => {
            finishLoading();
            throw error;
          });
        },
        isLoading: isLoading !== 0,
      }),
    ),
    omitProps(['setLoading', 'dispatch']),
    options.props ? mapProps(options.props) : identity,
  ),
);

export const withFetch = withContainer('fetch');
export const withCreate = withContainer('create');
export const withPatch = withContainer('patch');
export const withPut = withContainer('put');
export const withDelete = withContainer('del');
